import { Link, useParams } from "react-router-dom";

import { Card, CardContent } from "@/components/ui/card";
import { useEffect, useState } from "react";
import LikeRejectButtons from "@/components/view_profile/like-reject-buttons";
import ProfileGallery from "@/components/view_profile/profile-gallery";
import ProfileInfo from "@/components/view_profile/profile-info";
import axios from "axios";
import { BACKEND_URL } from "@/config";
import { useToken } from "@/global_state";
import { ChevronLeft } from "lucide-react";

type FullProfile = {
  name: string;
  age: number;
  genre: string;
  bio: string;
  image: string;
  image2: string;
  image3: string;
  image4: string;
  image5: string;
  image6: string;
};

export default function ProfileViewPage() {
  const { id } = useParams();
  const [profile, setProfile] = useState<FullProfile | null>(null);
  const [authToken, setAuthToken] = useToken();

  const fetchProfile = async () => {
    const response = await axios.get(`${BACKEND_URL}/api/users/${id}/profile/`);
    setProfile(response.data);
  };

  useEffect(() => {
    if (authToken) {
      fetchProfile();
    }
  }, [authToken]);

  const images = [
    profile?.image,
    profile?.image2,
    profile?.image3,
    profile?.image4,
    profile?.image5,
    profile?.image6,
  ].filter(Boolean) as string[];

  return (
    <div className="min-h-screen bg-gray-900 text-gray-100 py-8 px-4 sm:px-6 lg:px-8">
      <Link
        to="/app/home"
        className="inline-flex items-center mb-4 text-pink-500 hover:text-pink-400 transition-colors"
      >
        <ChevronLeft className="h-5 w-5 mr-1" />
        <span>Back</span>
      </Link>
      <Card className="max-w-md mx-auto bg-gray-800 border-gray-700">
        <CardContent className="p-0">
          <ProfileGallery images={images} />
          <div className="p-6">
            {profile && <ProfileInfo profile={profile} />}
            <LikeRejectButtons id={id} />
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
